module.exports = __webpack_public_path__ + "static/media/Lucian_0.f20ca11c.png";